var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41287 10.9286C0.821165 11.5203 0.821165 12.4797 1.41287 13.0714L11.0552 22.7137C11.6469 23.3054 12.6063 23.3054 13.198 22.7137C13.7897 22.122 13.7897 21.1627 13.198 20.571L4.62699 12L13.198 3.42901C13.7897 2.8373 13.7897 1.87796 13.198 1.28626C12.6063 0.694556 11.6469 0.694556 11.0552 1.28626L1.41287 10.9286ZM26.1206 10.4848L2.48424 10.4848L2.48424 13.5151L26.1206 13.5152L26.1206 10.4848Z",
    fill: "#1C2B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.e6865858165765375cbaa644a5362104.svg";
export { ForwardRef as ReactComponent };